import { render } from "./DocRequestDescriptionView.vue?vue&type=template&id=aa75d558"
import script from "./DocRequestDescriptionView.vue?vue&type=script&lang=js"
export * from "./DocRequestDescriptionView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__